import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMouseClassic: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mouse-classic, click"><path d="M19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V10.5H19V15Z" fill="currentColor"/><path d="M11.25 9H5C5 5.38739 7.73669 2.41428 11.25 2.04004V9Z" fill="currentColor"/><path d="M12.75 2.04004C16.2633 2.41428 19 5.38739 19 9H12.75V2.04004Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMouseClassic;
